import { render, staticRenderFns } from "./dandelion-product-detail-item.vue?vue&type=template&id=0fee48f8&scoped=true&"
import script from "./dandelion-product-detail-item.vue?vue&type=script&lang=js&"
export * from "./dandelion-product-detail-item.vue?vue&type=script&lang=js&"
import style0 from "./dandelion-product-detail-item.vue?vue&type=style&index=0&id=0fee48f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fee48f8",
  null
  
)

export default component.exports